import React, { useEffect, useState } from "react";
import "./Auth.css";
import ProLogin from "./ProLogin";
import Colors from "../Helper/Colors";
import GetToken from "./GetToken";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import useHttp from "../hooks/useHttp";
import LoadingPrimary from "../assets/loading_primary.svg";
import { toast } from "react-toastify";
// import { setAuthTab } from "../Redux/Actions/AuthAction";
import lang from "../Constant/lang.json";

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // const dispatch = useDispatch();
  const { HttpService } = useHttp();

  const [loading, setLoading] = useState(false);

  const getAutoLogin = async () => {
    try {
      setLoading(true);
      const response = await HttpService.post("/api/validate-auth-secret", {
        auth_secret: searchParams.get("auth_secret"),
      });
      setLoading(false);
      if (response.status < 400) {
        toast.success(lang.LOGIN_SUCCESSFULLY);
        localStorage.setItem("token", response.data.data?.token);
        localStorage.setItem("auth_from_admin", "1");
        // dispatch(setAuthTab(0));
        // navigate("/techapp");
        window.location.replace("/techapp");
      }
    } catch ({ err, response }) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchParams.get("auth_secret")?.length > 0) {
      getAutoLogin();
    } else if (localStorage.getItem("token")) {
      navigate("/techapp");
    }
  }, []);

  // const userMobile = useSelector((state) => state.AuthReducer.userMobile);
  const authTab = useSelector((state) => state.AuthReducer.authTab);

  return (
    <div
      style={{ backgroundColor: Colors.royalBlue, position: "relative" }}
      className="login"
    >
      {authTab === 0 && <ProLogin />}
      {authTab === 1 && <GetToken />}
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            position: "absolute",
            background: "rgba(255,255,255,0.75)",
            left: 0,
            top: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={LoadingPrimary}
            alt="Loading..."
            style={{ width: 50, height: 50 }}
          />
        </div>
      ) : null}
    </div>
  );
};
export default Login;
